module.exports = __webpack_public_path__ + "img/homeY.5f589efa.png";